/// <reference path="../shims.d.ts" />
// Maps doc slugs to their compiled MDX/MD modules. Centralized so the
// sidebar (nav.json), the index page, and the route loader all look at one
// source of truth. Adding a new page = drop the MDX into web/src/docs/,
// import it here, register the slug.

import CliReference from './_generated/cli-reference.md'
import SchemaReference from './_generated/schema-reference.md'
import Beta from './beta.mdx'
import DriftWorkflow from './drift-workflow.mdx'
import GithubAction from './github-action.mdx'
import GraphDrivenTesting from './graph-driven-testing.mdx'
import nav from './nav.json'
import Quickstart from './quickstart.mdx'
import VoiceTips from './voice-tips.mdx'

export const DOCS = {
  quickstart: Quickstart,
  'voice-tips': VoiceTips,
  'drift-workflow': DriftWorkflow,
  'github-action': GithubAction,
  'graph-driven-testing': GraphDrivenTesting,
  beta: Beta,
  'schema-reference': SchemaReference,
  'cli-reference': CliReference,
}

export const NAV = nav

/**
 * @param {string} slug
 */
export function getDoc(slug) {
  return DOCS[/** @type {keyof typeof DOCS} */ (slug)] ?? null
}

/**
 * @param {string} slug
 */
export function findNavItem(slug) {
  for (const section of nav.sections) {
    for (const item of section.items) {
      if (item.slug === slug) return { ...item, section: section.title }
    }
  }
  return null
}

export function allDocs() {
  const out = []
  for (const section of nav.sections) {
    for (const item of section.items) {
      out.push({ ...item, section: section.title })
    }
  }
  return out
}
